import { render, staticRenderFns } from "./FileIcon.vue?vue&type=template&id=03a58d6e&scoped=true&lang=pug"
import script from "./FileIcon.vue?vue&type=script&lang=js"
export * from "./FileIcon.vue?vue&type=script&lang=js"
import style0 from "./FileIcon.vue?vue&type=style&index=0&id=03a58d6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03a58d6e",
  null
  
)

export default component.exports